
import { NavigationTranslationType } from "../../features/navigation.types";

export const navigation: NavigationTranslationType = {
  navigation: {
    dashboard: "Dashboard",
    profile: "Profil",
    signOut: "Abmelden",
    upgradeRequired: "Upgrade erforderlich",
    basicSubscriptionRequired: "Grundlegende Abonnement erforderlich",
    premiumSubscriptionRequired: "Premium-Abonnement erforderlich",
  }
};
